import * as React from 'react';
import { Context, useContext, useState } from 'react';

export type WrokspacesInitializationContextProps = {
  isInitialized: boolean;
  setIsInitialized: (initialized: boolean) => void;
};

export const defaultWorkspacesInitializationContextProps: WrokspacesInitializationContextProps =
  {
    isInitialized: false,
    setIsInitialized: (_initialized: boolean) => {},
  };

export const WorkspacesInitializationContext: Context<WrokspacesInitializationContextProps> =
  React.createContext(defaultWorkspacesInitializationContextProps);

export const useWorkspaceInitializationContext =
  (): WrokspacesInitializationContextProps => {
    return useContext(WorkspacesInitializationContext);
  };

export const WorkspaceInitializationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    <WorkspacesInitializationContext.Provider
      value={{ isInitialized, setIsInitialized }}
    >
      {children}
    </WorkspacesInitializationContext.Provider>
  );
};
